/* TomorrowMade — The Daily (blog) behavior: archive filter, daily directive
   rotator, commit gadget, share, marquee. */
(function () {
  'use strict';

  /* archive filter by category (article tag) */
  var chips = document.querySelectorAll('.filters .chip');
  var notes = document.querySelectorAll('.note');
  if (chips.length && notes.length) {
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        var f = ch.getAttribute('data-filter');
        chips.forEach(function (c) { c.classList.toggle('on', c === ch); });
        notes.forEach(function (n) {
          var show = f === 'all' || (n.getAttribute('data-cat') || '').toLowerCase() === f;
          n.style.display = show ? '' : 'none';
          if (show && typeof gsap !== 'undefined' && !(window.TM && window.TM.reduce)) {
            gsap.fromTo(n, { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: 0.5, ease: 'expo.out' });
          }
        });
      });
    });
  }

  /* daily directive rotator */
  var directives = [
    'Do the hard thing first.', 'Pick the task you are avoiding — start it now.',
    'Ship something today, even if it is rough.', 'Cut one distraction for the next hour.',
    'Make the call you keep postponing.', 'Move before you feel ready.',
    'Finish what you started yesterday.', 'Choose discipline over mood.',
    'Take the first ten minutes. Just the first ten.'
  ];
  var dtext = document.getElementById('dtext'), dnum = document.getElementById('dnum'), dnext = document.getElementById('dnext');
  var di = 0;
  if (dnext && dtext) {
    dnext.addEventListener('click', function () {
      di = (di + 1) % directives.length;
      dtext.textContent = directives[di];
      if (dnum) dnum.textContent = 'No. ' + ('0' + (di + 1)).slice(-2);
    });
  }

  /* commit gadget (localStorage) */
  var cinput = document.getElementById('cinput'), cbtn = document.getElementById('cbtn'), cdone = document.getElementById('cdone');
  function commit() {
    if (!cinput || !cinput.value.trim()) return;
    var v = cinput.value.trim();
    try { localStorage.setItem('tm_commit', v); } catch (e) {}
    if (cdone) { cdone.textContent = '/// Locked in: ' + v; cdone.classList.add('show'); }
    cinput.value = '';
  }
  if (cbtn) cbtn.addEventListener('click', commit);
  if (cinput) cinput.addEventListener('keydown', function (e) { if (e.key === 'Enter') commit(); });
  try {
    var saved = localStorage.getItem('tm_commit');
    if (saved && cdone) { cdone.textContent = '/// Locked in: ' + saved; cdone.classList.add('show'); }
  } catch (e) {}

  /* share */
  document.querySelectorAll('[data-share]').forEach(function (b) {
    b.addEventListener('click', function () {
      var titleEl = document.querySelector('.today__title, .ehero__in h1, h1');
      var t = titleEl ? titleEl.textContent.trim() : document.title;
      if (navigator.share) { navigator.share({ title: 'TomorrowMade — The Daily', text: t, url: location.href }).catch(function () {}); }
      else {
        var orig = b.textContent;
        b.textContent = 'Link copied';
        try { navigator.clipboard.writeText(location.href); } catch (e) {}
        setTimeout(function () { b.textContent = orig; }, 1600);
      }
    });
  });

  /* marquee */
  var mq = document.getElementById('mq1');
  if (mq && !mq.innerHTML.trim()) {
    var items = ['Today Is The Work', 'No Standing Still', 'Discipline Over Motivation', 'Built Today', 'Earn Tomorrow'];
    var html = '';
    for (var r = 0; r < 2; r++) { items.forEach(function (x) { html += '<span>' + x + '<b> ///</b><i class="dot"></i></span>'; }); }
    mq.innerHTML = html;
    window.addEventListener('load', function () {
      if (typeof gsap !== 'undefined' && !(window.TM && window.TM.reduce)) {
        var w = mq.scrollWidth / 2; gsap.to(mq, { x: -w, duration: 28, ease: 'none', repeat: -1 });
      }
    });
  }
})();
